import { render } from "./UsersTypeTms.vue?vue&type=template&id=7a0884e4"
import script from "./UsersTypeTms.vue?vue&type=script&lang=js"
export * from "./UsersTypeTms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__